// extracted by mini-css-extract-plugin
export default {"resumeButton":"ResumeButton_resumeButton__dMc8M"};